import React, { InputHTMLAttributes } from 'react';
import Search from './icons/ic_search_24px.svg'
import './Input.scss';

export interface UHCInputProps extends  InputHTMLAttributes<HTMLInputElement> {
    icon?: {
        type?: 'search'|''
        onClick?: Function
    }
}

const UHCInput: React.FC<UHCInputProps> = (props:UHCInputProps) => {
    return (
        <div data-testid='UHCInputComponent' className={`zero-form-field ${!props.placeholder ? 'without-placeholder' : ''}`}>
            <input {...props} />
            <label>{props.placeholder}</label>
            {
                props.icon.type ?
                    <img src={props.icon.type ? Search : ''} onClick={() => (props.icon.onClick) ? props.icon.onClick() : null} alt='' />
                    : null
            }
        </div>
    );
};

export default UHCInput;
